import { CONVERSATIONS_SECTION } from 'app/constants/collaborator-section.constants';
import * as i0 from "@angular/core";
export class CollaboratorAccessService {
    canActivate() {
        return this.ensureCollaboratorHasAccessOrRedirect(CONVERSATIONS_SECTION);
    }
    ensureCollaboratorHasAccessOrRedirect(sectionId) {
        const ensureCollaboratorHasAccessOrRedirect = window['ensureCollaboratorHasAccessOrRedirect'];
        if (typeof ensureCollaboratorHasAccessOrRedirect === 'function') {
            return Promise.resolve(ensureCollaboratorHasAccessOrRedirect(sectionId));
        }
        return new Promise(resolve => {
            setTimeout(() => {
                const retryEnsureCollaboratorHasAccessOrRedirect = window['ensureCollaboratorHasAccessOrRedirect'];
                if (typeof retryEnsureCollaboratorHasAccessOrRedirect === 'function') {
                    resolve(retryEnsureCollaboratorHasAccessOrRedirect(sectionId));
                    return;
                }
                resolve(true);
            }, 1000);
        });
    }
}
CollaboratorAccessService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CollaboratorAccessService_Factory() { return new CollaboratorAccessService(); }, token: CollaboratorAccessService, providedIn: "root" });
